<template>
  <div class="container">
    <mt-header fixed :title="(auth.edit?'编辑':'')+'客户信息'" class="head">
      <div slot="left" @click="toBackClick">
        <mt-button icon="back"></mt-button>
      </div>
      <mt-button v-show="auth.edit" slot="right" style="font-size:.4rem" @click="saveOrderClick">保存</mt-button>
      <mt-button v-show="!auth.edit" slot="right" style="font-size:.4rem" @click="editOrderClick">编辑</mt-button>
    </mt-header>
    <div class="c_p_t_10 ">
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          客户姓名
        </div>
        <div class="item-content">
              <span class="item-value" :class="auth.edit?'':'c_no_pointer'">
                <input type="text" :placeholder="auth.edit?'请填写客户姓名':'--'" @change="autoSave('contactname',userinfo.contactname)"
                       v-model="userinfo.contactname">
              </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          客户手机号
        </div>
        <div class="item-content">
            <span class="item-value " :class="auth.edit?'':'c_no_pointer'">
                <input type="number" :placeholder="auth.edit?'请填写客户手机号':'--'" maxlength="11"
                       @change="autoSave('contactphone',userinfo.contactphone)" v-model="userinfo.contactphone">
            </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white" @click="addrClick" :class="auth.edit?'':'c_no_pointer'">
          <div class="item-title c_nowrap">
            <!--<span class="c_red">*</span>-->
            所在区域
          </div>
          <div class="item-content">
                  <span class="item-value c_no_pointer c_nowrap">
                      {{(userinfo.province == userinfo.city ? userinfo.province + userinfo.district : userinfo.province + userinfo.city + userinfo.district)||(auth.edit?'请选择详细地址':'--')}}
                  </span>
            <!-- <span class="item-point">···</span> -->
          </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          详细地址
        </div>
        <div class="item-content c_flex c_flex_center">
              <span class="item-value" style="width:100%;" :class="auth.edit?'':'c_no_pointer'">
                  <input type="text" :placeholder="auth.edit?'请填写详细地址':'--'"
                         @change="autoSave('address',userinfo.address)" v-model="userinfo.address">
              </span>
          <span class="item-point c_flex c_flex_center">
                <!--<i class="iconfont icon-bianjisekuai"></i>-->
              </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          维修面积
        </div>
        <div class="item-content c_flex c_flex_center">
              <span class="item-value" style="width:100%;" :class="auth.edit?'':'c_no_pointer'">
                  <input type="number" :placeholder="auth.edit?'请填写维修面积':'--'" @change="autoSave('area',userinfo.area)"
                         v-model="userinfo.area">
              </span>
          <span class="item-point c_flex c_flex_center">
                <!--<i class="iconfont icon-bianjisekuai"></i>-->
              </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white" @click="typeClick" :class="auth.edit?'':'c_no_pointer'">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          房屋类型
        </div>
        <div class="item-content">
                <span class="item-value c_no_pointer">
                    <input type="text" :placeholder="auth.edit?'请选择房屋类型':'--'" @change="autoSave('type',userinfo.type)"
                           v-model="userinfo.type">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          渗漏部位
        </div>
        <div class="item-content">
                <span class="item-value" :class="auth.edit?'':'c_no_pointer'">
                    <input type="text" :placeholder="auth.edit?'请填写渗漏部位':'--'" @change="autoSave('part',userinfo.part)"
                           v-model="userinfo.part">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          备注
        </div>
        <div class="item-content">
                <span class="item-value" :class="auth.edit?'':'c_no_pointer'">
                    <input type="text" :placeholder="auth.edit?'请填写备注':'--'"
                           @change="autoSave('reason',userinfo.reason)" v-model="userinfo.reason">
                </span>
          <!-- <span class="item-point">···</span> -->
        </div>
      </div>

      <!--<div @click="saveOrderClick" class="item-save bg_blue c_center">确认下单</div>-->

    </div>

    <!--选择省市区-->
    <c-area @saveAddrClick="saveAddrClick" :addrtemp="addr" :province="userinfo.province" :city="userinfo.city"
            :district="userinfo.district">
    </c-area>


    <c-model @saveClick="saveTypeClick" :isShow="type_params.isShow">
      <template slot="title">选择房屋类型</template>
      <template slot="main">
        <mt-checklist
          v-model="type_arr"
          :options="typeList">
        </mt-checklist>
      </template>
    </c-model>

  </div>
</template>

<script>
  import {Toast} from 'mint-ui';
  import cArea from './c-area'
  import cModel from './c-model'

  // import {Checklist} from 'mint-ui';

  export default {
    name: "bookservice",
    components: {
      cArea,cModel
    },
    data: function () {
      return {
        customerid: '',
        houseid: '',
        type_arr: [],
        userinfo: {
          name: '',
          phone: '',
          contactname:'',
          contactphone:'',
          type: '',
          province: '',
          city: '',
          district: '',
          address: '',
          area: '',
          part: '',
          reason: '',
        },
        addr: {
          chooseType: 'province',
          province: '',
          city: '',
          district: '',
          hotList: [
            {name: '北京', type: 'district', province: '北京市', city: '北京市', district: ''},
            {name: '天津', type: 'district', province: '天津市', city: '天津市', district: ''},
            {name: '四川', type: 'city', province: '四川省', city: '', district: ''},
            {name: '陕西', type: 'city', province: '陕西省', city: '', district: ''},
            {name: '武汉', type: 'district', province: '湖北省', city: '武汉市', district: ''},
            {name: '上海', type: 'district', province: '上海市', city: '上海市', district: ''},
            {name: '杭州', type: 'district', province: '浙江省', city: '杭州市', district: ''},
            {name: '广州', type: 'district', province: '广东省', city: '广州市', district: ''},
          ],
          chooseList: [],
          provinceList: [],
          cityList: [],
          districtList: [],
          isShow: false,
        },
        type_params: {
          isShow: false,
        },
        typeList:[
          {label: "平屋面",value:"平屋面"},
          {label: "露台",value:"露台"},
          {label: "斜屋面",value:"斜屋面"},
          {label: "卫生间",value:"卫生间"},
          {label: "窗口",value:"窗口"},
          {label: "采光顶",value:"采光顶"},
          {label: "金属屋面",value:"金属屋面"},
          {label: "外墙",value:"外墙"},
          {label: "厨房",value:"厨房"},
          {label: "地下室",value:"地下室"},
          {label: "水池",value:"水池"}
        ],
        auth: {
          edit: false,
          //是否开启自动保存
          isAutoSave: false,
        },
      }
    },
    mounted: function () {
      var obj = JSON.parse(localStorage['obj']);
      this.customerid = obj.customerid;
      this.getUserInfo();
    },
    methods: {
      // 获取用户信息
      getUserInfo: function () {
        let $that = this;
        //：：获取客户信息，而不是 登录的用户
        this.$ajax.get(this.$$api.mobile.getCustomerInfo, {
          customerid: this.customerid
        }, response => {
          if (response.status >= 200 && response.status < 300) {
            let msg = response.data.detailMsg.data;
            $that.userinfo = msg || {};
            $that.userinfo.contactname = msg.contactname || msg.name;
            $that.userinfo.contactphone = msg.contactphone || msg.phone;
            $that.houseid = msg.houseid;
            if(msg.type){
              if(msg.type.indexOf(',')>-1){
                $that.type_arr = msg.type.split(',')
              }else{
                $that.type_arr.push(msg.type)
              }
            }
            $that.auth.isAutoSave = true;
          } else {
            console.log(response, 0);
          }
        });
      },
      // 选择省市区
      addrClick: function () {
        this.addr.isShow = true;
      },
      saveAddrClick: function (addr) {
        this.userinfo.province = addr.province;
        this.userinfo.city = addr.city;
        this.userinfo.district = addr.district;
        this.addr = addr;
        this.autoSave('province', addr.province);
        this.autoSave('city', addr.city);
        this.autoSave('district', addr.district);
      },
      // 选择房屋类型
      typeClick: function () {
        this.type_params.isShow = true;
      },
      saveTypeClick: function (obj) {
        // this.userinfo.type = obj.name;
        this.type_params.isShow = false;
      },
      // 保存
      saveOrderClick: function () {
        let $that = this;
        let obj = {};
        obj.name = this.userinfo.name;
        obj.phone = this.userinfo.phone;
        obj.contactname = this.userinfo.contactname;
        obj.contactphone = this.userinfo.contactphone;
        obj.type = this.userinfo.type;
        obj.province = this.userinfo.province;
        obj.city = this.userinfo.city;
        obj.district = this.userinfo.district;
        obj.address = this.userinfo.address;
        obj.area = this.userinfo.area;
        obj.part = this.userinfo.part;
        obj.reason = this.userinfo.reason;
        obj.customerid = this.userinfo.customerid;
        obj.houseid = this.userinfo.houseid;
        if (!obj.contactname) {
          Toast({message: '请填写客户姓名', duration: 1500});
          return;
        }
        if (!obj.contactphone) {
          Toast({message: '请填写客户手机号', duration: 1500});
          return;
        }
        // if (!obj.address) {
        //   Toast({message: '请填写详细地址', duration: 1500});
        //   return;
        // }
        // if (!obj.area) {
        //   Toast({message: '请填写维修面积', duration: 1500});
        //   return;
        // }
        // if (!obj.type) {
        //   Toast({message: '请选择房屋类型', duration: 1500});
        //   return;
        // }
        // if (!obj.part) {
        //   Toast({message: '请填写渗漏部位', duration: 1500});
        //   return;
        // }
        // this.$ajax.post(this.$$api.mobile.editCustomerInfo, {
        //   customer: JSON.stringify(obj)
        // }, function (res) {
        $that.auth.edit = false;
        // var obj = JSON.parse(localStorage['obj']);
        // obj.name = $that.userinfo.name;
        // obj.phone = $that.userinfo.phone;
        // localStorage['obj'] = JSON.stringify(obj);
        // $that.$router.go(-1);
        // });
      },
      toBackClick: function () {
        this.$router.go(-1);
      },
      editOrderClick: function () {
        this.auth.edit = true;
      },
      //自动保存
      autoSave(type, value) {
        let $that = this;
        if (type && this.customerid && this.houseid && this.auth.isAutoSave) {
          this.$ajax.post(this.$$api.mobile.editCustomerInfo, {
            'customerid': this.customerid,
            'houseid': this.houseid,
            'attribute': type,
            'value': value
          }, response => {
            if (response.status >= 200 && response.status < 300) {
              // console.log(response);
              if (type == 'contactname' || type == 'contactphone')
                var obj = JSON.parse(localStorage['obj']);
              obj.contactname = $that.userinfo.contactname;
              obj.contactphone = $that.userinfo.contactphone;
              localStorage['obj'] = JSON.stringify(obj);
            } else {
              // console.log(response,this.sid);
            }
          });
        }
      },

    },
    watch: {
      type_arr:function(val){
        this.userinfo.type = val.join(',');
        this.autoSave('type',val.join(','));
      },
    },


  }
</script>

<style scoped>
  .container {
    font-size: 4vw;
  }

  ::-webkit-input-placeholder {
    font-size: 3.5vw;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
  }

  .item-title {
    width: 35%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 65%;
    text-align: right;
    font-size: 3.5vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 3.5vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
    /*background: red;*/
  }

  .product-title label {
    width: 100%;
    height: 100%;
    display: inline-block;
    display: flex;
    align-items: center;
  }

  .item-point i {
    font-size: .5rem;
  }

  .item-save {
    width: 25vw;
    color: #fff;
    height: 10.53vw;
    line-height: 10.53vw;
    font-size: 3.871vw;
    margin: auto;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }


</style>



// WEBPACK FOOTER //
// src/components/customerDetail.vue